import { BookingForm } from "./BookingForm";
import { BookingsToday } from "./BookingsToday";

export function PartiesPanel() {
  return (
    <div className="space-y-5">
      <BookingForm />
      <BookingsToday />
    </div>
  );
}
